import React, { forwardRef, useCallback } from 'react';
import { Controller, get, useFormContext } from 'react-hook-form';

export const Textarea = forwardRef((props, ref) => {
  const { rows = 1, className, onChange, name, label, error, maxLength, ...restProps } = props;
  const handleChange = useCallback(
    (e) => {
      onChange?.(e.target.value);
    },
    [onChange]
  );

  return (
    <div className={`relative mb-4`}>
      {label && (
        <label htmlFor={name} className="block text-gray-700 text-sm ml-2 mb-2">
          {label}
        </label>
      )}
      <div className="flex flex-row relative min-h-10">
        <textarea
          className={`appearance-none border min-h-10 border-gray-300 w-full rounded-lg p-3 text-gray-700 leading-tight focus:outline-none ${className}`}
          id={name}
          maxLength={maxLength}
          ref={ref}
          rows={rows}
          onChange={handleChange}
          {...restProps}
        />

        {error && <span className={'absolute bottom-[-16px] text-xs text-red-500'}>*{error?.message}</span>}
      </div>
    </div>
  );
});

Textarea.displayName = 'Textarea';

export const ControlledTextArea = forwardRef((props, ref) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { name, onChange, rules, defaultValue } = props;

  const error = get(errors, name);

  return (
    <Controller
      control={control}
      name={name ?? ''}
      rules={rules && rules}
      defaultValue={defaultValue}
      render={({ field }) => {
        return (
          <Textarea
            ref={ref}
            {...field}
            {...props}
            error={error}
            onChange={(value) => {
              onChange?.(value);
              field.onChange(value);
            }}
          />
        );
      }}
    />
  );
});

ControlledTextArea.displayName = 'ControlledTextArea';
